// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      wm-poi-types-badges {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        margin: var(--wm-feature-details-margin);

        > div {
          display: flex;
          flex-direction: row;
          border: 1px solid var(--wm-color-medium);
          border-radius: 24px;
          padding: 4px 8px;
          color: var(--wm-color-medium);
          align-items: center;

          div {
            display: flex;
          }

          svg {
            width: 20px;
            height: 20px;
            margin-right: 8px;

            circle {
              fill: var(--wm-color-medium);
            }
          }

          span {
            color: var(--wm-color-medium);
            font-size: 14px;
            font-weight: 600;
          }
        }
      }
    `, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/poi-types-badges/poi-types-badges.component.ts"],"names":[],"mappings":";MACM;QACE,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,QAAQ;QACR,wCAAwC;;QAExC;UACE,aAAa;UACb,mBAAmB;UACnB,wCAAwC;UACxC,mBAAmB;UACnB,gBAAgB;UAChB,6BAA6B;UAC7B,mBAAmB;;UAEnB;YACE,aAAa;UACf;;UAEA;YACE,WAAW;YACX,YAAY;YACZ,iBAAiB;;YAEjB;cACE,4BAA4B;YAC9B;UACF;;UAEA;YACE,6BAA6B;YAC7B,eAAe;YACf,gBAAgB;UAClB;QACF;MACF","sourcesContent":["\n      wm-poi-types-badges {\n        position: relative;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        gap: 8px;\n        margin: var(--wm-feature-details-margin);\n\n        > div {\n          display: flex;\n          flex-direction: row;\n          border: 1px solid var(--wm-color-medium);\n          border-radius: 24px;\n          padding: 4px 8px;\n          color: var(--wm-color-medium);\n          align-items: center;\n\n          div {\n            display: flex;\n          }\n\n          svg {\n            width: 20px;\n            height: 20px;\n            margin-right: 8px;\n\n            circle {\n              fill: var(--wm-color-medium);\n            }\n          }\n\n          span {\n            color: var(--wm-color-medium);\n            font-size: 14px;\n            font-weight: 600;\n          }\n        }\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
